import http from '@/utils/http'

export const getTeacherList = (params) => http.post('/marking-user/user/teacher/list_teacher_region', params) // 获取教师档案列表
export const getPoints = (params) => http.get('/marking-report/region/teacher/classExamKnowledge', params, 'form') // 获取知识点掌握情况
export const getExam = (params) => http.get('/marking-report/region/teacher/classExam', params, 'form') // 获取考试排名

export const getStudentExamNum = (params) => http.get('/marking-main/exam/exam/get_stud_exam_num', params, 'form') //查看学生考试统计
export const getStudentLocus = (id) => http.get('/marking-platform/students/' + id, { infos: 'LOCUS' }) //获取学生轨迹

export const getStudentBestExam = (params) => http.get('/marking-report/region/student/bestExam', params, 'form') //获取学生最优考试

export const getAuthSubjectList = (params) => http.expired('/marking-user/user/school/get_perm_subject', params, 'form') // 查询权限学科


